import { Heading, Container, Box } from 'theme-ui';

import { convertAlignToFlex } from '@utils';
import { Link } from '@snippets';

import { themed } from './Header.theme';

export const Header = themed(({ theme, content = {}, headerPaddingRight = 0 }) => {
  const { textAlign, textAlignMobile, heading, headingTag, cta, ctaStyle } = content;
  const HeadingTag = headingTag || 'h2';

  return (
    <Container
      data-comp={Header.displayName}
      sx={{
        ...theme.header,
        justifyContent: [
          convertAlignToFlex(textAlignMobile),
          null,
          null,
          convertAlignToFlex(textAlign),
        ],
        alignItems: [
          convertAlignToFlex(textAlignMobile),
          null,
          null,
          convertAlignToFlex(textAlign),
        ],
        paddingRight: [0, null, null, headerPaddingRight],
      }}
    >
      <Box sx={theme.contentWrapper}>
        <Heading
          as={HeadingTag}
          variant="h2"
          sx={{
            ...theme.heading(headingTag || 'h2'),
            textAlign,
          }}
        >
          {heading}
        </Heading>
      </Box>
      {cta?.text && cta?.url && (
        <Link
          href={cta.url}
          newTab={cta.newTab}
          variant={`buttons.${ctaStyle || 'primary'}`}
          sx={theme.cta}
          className="max-md:!hidden"
        >
          {cta.text}
        </Link>
      )}
    </Container>
  );
});

Header.displayName = 'Header';